module.exports = __webpack_public_path__ + "media/images/illustrations/flat_clip_done-509599182df2e0921df630065cee992b.png";